// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"b3678ef8","453":"560be68f","458":"61514712","678":"260eadf3","804":"42f5f7b4","813":"bbd5b4af","837":"b143d704"}[chunkId] + ".chunk.js";
};